import { EventType } from './event-type.interface';

export const BLINDS: EventType = {
  name: 'Blinds and Shades',
  description: 'When blinds or shades are open or closed',
  route: 'blinds',
  category: 'Security & Access',
  icon: 'shades',
  whitelist: [
    {
      proxy: 'blind',
      events: [2, 4]
    },
    {
      proxy: 'blindV2',
      events: [1, 2]
    },
    {
      proxy: 'shade',
      events: [1, 2, 3]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/blinds.type.ts